<template>
  <span>
    <template v-if="component.properties && component.properties.html">
      <template v-if="component.properties.route">
        <component
            v-bind="component.properties"
            v-bind:is="component.vuetify"
            v-html="component.properties.html"
            @click="goToPage(component.properties.route, $event)"
        />
      </template>
      <template v-else>
        <component
            v-bind="component.properties"
            v-bind:is="component.vuetify"
            v-html="component.properties.html"
        />
      </template>
      <template
          v-for="(element, index) in component.elements"
      >
        <section
            :key="index"
            v-if="element.type && element.type ==='layout'"
        >
          <template
              v-for="(section, i) in element.sections"
          >
            <sub-dynamic-section :key="i" :context="section"/>
          </template>
        </section>

        <v-divider
            :key="index"
            v-else-if="element.vuetify ==='v-divider'"
            v-bind="element.properties"
        />

        <dynamic-component
            v-else
            :key="index"
            :component="element"
            @tabsChanged="tabsChanged"
        />

      </template>
    </template>
    <template v-else-if="component.vuetify ==='v-img'">
      <template v-if="component.route">
        <a
            :href="getURLLocalGlobal(component.route.url)"
            :target="component.route.target"
        >
          <v-img
              v-bind="component.properties"
          />
        </a>
      </template>
      <v-img
          v-else
          v-bind="component.properties"
      />
    </template>
    <template v-else-if="component.vuetify === 'v-btn'">
      <v-btn
          v-if="component.route && component.route.url"
          link
          v-bind="component.properties"
          :href="(component.route && component.route.url) ? getURLLocalGlobal(component.route.url) : ''"
          :target="(component.route && component.route.target ) ? component.route.target.toLowerCase() : ''"
      >
        <v-icon v-if="component.properties.icon">{{ component.properties.icon }}</v-icon>
        {{ component.properties.label }}
      </v-btn>
      <v-btn
          v-else
          v-bind="component.properties"
          :href="(component.route) ? getURLLocalGlobal(component.route.url): ''"
          link
          :target="(component.route) ? component.route.url : ''"
      >
        {{ component.properties.label }}
      </v-btn>
    </template>
    <template v-else-if="component.vuetify === 'video'">
      <video v-bind="component.properties" playsinline>
        <source :src="component.media.src" :type="component.media.type">
        Your browser does not support the video tag.
      </video>
    </template>
    <template v-else-if="component.vuetify === 'audio'">
      <audio v-bind="component.properties">
        <source :src="component.media.src" :type="component.media.type">
        Your browser does not support the audio tag.
      </audio>
    </template>
    <template v-else-if="component.vuetify === 'v-add-search'">
      <add-search
          :context="component"
      ></add-search>
    </template>
    <template v-else-if="component.vuetify === 'image-gallery'">
      <image-gallery :context="component"></image-gallery>
    </template>
    <template v-else-if="component.vuetify === 'dynamic-abstract'">
      <dynamic-abstract
          :context="component"
      />
    </template>
    <template v-else-if="component.vuetify === 'v-tabs'">
      <v-tabs
          v-model="elementTab"
          v-bind="component.properties"
      >

          <v-tab
              v-for="(oneTabItem, tabIndex) in component.elements"
              :key="tabIndex"
              v-bind="oneTabItem.properties"
              @change="changeTab(component.refTabs, oneTabItem, tabIndex, $event)"
          >{{ oneTabItem.properties.text }}</v-tab>
      </v-tabs>
    </template>
    <template v-else-if="component.vuetify === 'v-tabs-items'">
      <v-tabs-items
          v-bind="component.properties"
          v-model="elementTab"
      >
        <v-tab-item
            v-for="(oneTabItem, tabIndex) in component.elements"
            :key="tabIndex"
        >
            <dynamic-component
                v-for="(oneTabItemEle, oneTabItemEleIndex) in oneTabItem.elements"
                :key="oneTabItemEleIndex"
                :component="oneTabItemEle"
                @tabsChanged="tabsChanged"
            />
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-else-if="component.elements">

      <template v-if="component.properties.route">
        <component
            v-bind:is="component.vuetify"
            v-bind="component.properties"
            @click="goToPage(component.properties.route, $event)"
        >
        <template
            v-for="(element, index) in component.elements"
        >
          <section
              :key="index"
              v-if="element.type && element.type ==='layout'"
          >
            <template
                v-for="(section, i) in element.sections"
            >
              <sub-dynamic-section :key="i" :context="section"/>
            </template>
          </section>

          <v-divider
              :key="index"
              v-else-if="element.vuetify ==='v-divider'"
              v-bind="element.properties"
          />

          <dynamic-component
              v-else
              :key="index"
              :component="element"
              @tabsChanged="tabsChanged"
          />

        </template>
      </component>
      </template>
      <template v-else>
        <component
            v-bind:is="component.vuetify"
            v-bind="component.properties"
        >
        <template
            v-for="(element, index) in component.elements"
        >
          <section
              :key="index"
              v-if="element.type && element.type ==='layout'"
          >
            <template
                v-for="(section, i) in element.sections"
            >
              <sub-dynamic-section :key="i" :context="section"/>
            </template>
          </section>

          <v-divider
              :key="index"
              v-else-if="element.vuetify ==='v-divider'"
              v-bind="element.properties"
          />

          <dynamic-component
              v-else
              :key="index"
              :component="element"
              @tabsChanged="tabsChanged"
          />
        </template>
      </component>
      </template>
    </template>
    <template v-else>
      <template v-if="component.properties.route">
        <component
            v-bind:is="component.vuetify"
            v-bind="component.properties"
            @click="goToPage(component.properties.route, $event)"
        />
      </template>
      <template v-else>
        <component
            v-bind:is="component.vuetify"
            v-bind="component.properties"
        />
      </template>
    </template>
  </span>
</template>
<script>
import AddSearch from "@/components/AddSearch";
import globalMixins from "@/mixins/globalMixins";
import ImageGallery from "@/components/ImageGallery";

export default {
  name: 'DynamicComponent',
  props: {
    component: {
      type: Object
    }
  },

  mixins: [globalMixins],

  data() {
    return {
      elementTab: 0,
      lazysrc: require('@/assets/lazysrc.jpg')
    }
  },

  components: {
    'SubDynamicSection': () => import('./DynamicSection.vue'),
    AddSearch,
    ImageGallery
  },

  async created() {
    if (this.component.properties.class)
      this.component.properties.class = this.component.properties.class.toLowerCase();

    if (this.component.properties.color)
      this.component.properties.color = this.component.properties.color.toLowerCase();

    switch (this.component.vuetify) {
      case 'v-tabs':
        this.component.refTabs = this.component.properties['v-internal-label'];
        if (this.$store.getters['tabs/get'](this.component.refTabs) === undefined) {
          this.$store.dispatch('tabs/set', [this.component.refTabs, 0]);
        }
        break;
      case 'v-tabs-items':
        this.component.refTabs = this.component.properties['v-internal-label'].replace('Items', '');
        if (this.$store.getters['tabs/get'](this.component.refTabs) === undefined) {
          this.$store.dispatch('tabs/set', [this.component.refTabs, 0]);
        }
        break;
      case 'v-tab':
        if (this.component.properties && this.component.properties.text) {
          this.component.properties.html = this.component.properties.text;
          delete this.component.properties.text;
        }
        break;
      case 'v-tab-item':
        this.component.properties.id = this.component.properties['v-tab-id'];
        delete this.component.properties['v-tab-id'];
        break;
      case 'v-card':
        if (this.component.properties.image) {
          this.component.properties.img = this.component.properties.imageCrop || this.component.properties.image;
          delete this.component.properties.imageCrop;
          delete this.component.properties.image;
        }
        if (this.component.properties.href && this.component.properties.href.url) {
          let componentURL = this.component.properties.href.url;
          this.component.properties.route = {
            route: {
              url: componentURL,
              target: "_" + this.component.properties.target
            }
          };
          this.component.properties.link = true;
          delete this.component.properties.href;// = componentURL;
        }
        break;
      case 'v-img':
        for (let i in this.component.properties) {
          if (typeof this.component.properties[i] === 'string' && this.component.properties[i].trim() === '') {
            delete this.component.properties[i];
          }
        }
        if (!this.component.properties['lazy-src']) {
          this.component.properties['lazy-src'] = this.lazysrc;
        }
        this.component.properties.src = this.component.properties.imageCrop || this.component.properties.image;

        if (this.component.properties.url) {
          this.component.route = this._.cloneDeep(this.component.properties.url);
        }

        delete this.component.properties.imageCrop;
        delete this.component.properties.image;
        delete this.component.properties.url;
        this.$forceUpdate();
        break;
      case 'v-btn':
        if (this.component.properties.href) {
          this.component.route = this.component.properties.href;
          delete this.component.properties.href;
        } else if (this.component.properties.link) {
          this.component.route = this.component.properties.link;
          delete this.component.properties.link;
        }
        break;
      case 'audio':
        this.component.media = {
          type: this.component.properties.type,
          src: this.component.properties.src
        };
        delete this.component.properties.type;
        delete this.component.properties.src;
        break;
      case 'video':
        this.component.media = {
          type: this.component.properties.type,
          src: this.component.properties.src
        };
        delete this.component.properties.type;
        delete this.component.properties.src;
        break;
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        if (!this.component.properties.class) {
          this.component.properties.class = '';
        }
        this.component.properties.class = `text-${this.component.vuetify} ${this.component.properties.class}`;
        break;
      default:
        break;
    }
  },

  methods: {}
}
</script>